import { ComponentType, FC, ComponentProps, useRef, useCallback } from 'react';
import { useFragment, graphql } from 'react-relay';
import { VisibilityTracker } from 'dibs-visibility-tracker/exports/VisibilityTracker';
import { trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2';

import { useShowPricingGuidance } from './useShowPricingGuidance';

const itemFragment = graphql`
    fragment pricingGuidanceAbHoc_item on Item {
        ...useShowPricingGuidance_item
    }
`;

export const pricingGuidanceAbHoc = <P extends { item: $TSFixMe; currency: string }>(
    Component: ComponentType<P>
): FC<P> => {
    const PricingGuidanceHOC: FC<P> = props => {
        const item = useFragment(itemFragment, props.item);
        const ref = useRef(null);

        const showPricingGuidance = useShowPricingGuidance({
            item,
            currency: props.currency,
            includeVariantCheck: false,
        });

        const onVisibilityChange: ComponentProps<typeof VisibilityTracker>['onVisibilityChange'] =
            useCallback(
                ({ isVisible }) => {
                    if (isVisible && showPricingGuidance) {
                        trackAbTestV2Variant('PDPpricingguidance');
                    }
                },
                [showPricingGuidance]
            );

        return (
            <div ref={ref}>
                <VisibilityTracker
                    elementRef={ref}
                    onVisibilityChange={onVisibilityChange}
                    observerOptions={{
                        threshold: 0.6,
                    }}
                />
                <Component {...props} />
            </div>
        );
    };

    return PricingGuidanceHOC;
};
